import useFindTokens from '@plug-core/hooks/useFindTokens'
import React, { PropsWithChildren, createContext, useCallback, useContext, useState } from 'react'

export interface FindTokensContextType {
  findTokens: (principalId: string) => Promise<void>
  loading: boolean
}

export const FindTokensContext = createContext<FindTokensContextType>(null as any)

const FindTokensProvider = ({ children }: PropsWithChildren) => {
  const [loading, setLoading] = useState(false)
  const { findTokens: findTokensBase } = useFindTokens()

  const findTokens = useCallback(
    async (principalId: string) => {
      setLoading(true)
      await findTokensBase(principalId)
      setLoading(false)
    },
    [findTokensBase]
  )

  return (
    <FindTokensContext.Provider value={{ findTokens, loading }}>
      {children}
    </FindTokensContext.Provider>
  )
}

export const useFindTokensProvider = () => {
  return useContext(FindTokensContext)
}

export default FindTokensProvider
